/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { routes } from 'const';
import { useFetchInboundMessagesMeta } from 'hooks';
import { TabPanel } from 'components/elements';
import ChatListInactiveMessages from './ChatListInactiveMessages';
import ChatListInboundMessages from './ChatListInboundMessages';
import Styles from './styles';

const useStyles = makeStyles(Styles);

const a11yProps = (index) => ({
  id: `simple-tab-${index}`,
  'aria-controls': `simple-tabpanel-${index}`,
});

function ChatList({ selectedConversationId, onSelectMessage }) {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation('labels');
  const { unreadCount } = useFetchInboundMessagesMeta();
  const onSelectConversation = (id) => () => {
    history.push(`${routes.messages}/${id}`);
    onSelectMessage();
  };

  const [tabValue, setTabValue] = useState(0);
  const handleChange = (event, newTabValue) => setTabValue(newTabValue);

  return (
    <div className={classes.chatList} data-testid="chat-list">
      <Box className={classes.tabsHeader}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            classes={{
              flexContainer: classes.tabsContainer,
            }}
            value={tabValue}
            onChange={handleChange}
            aria-label="messages tabs"
          >
            <Tab
              classes={{ root: classes.tab }}
              label={
                <div className={classes.activeTabWrap}>
                  <Typography sx={{ fontWeight: 'bold' }} variant="h5" component="span">
                    {t('active')}
                  </Typography>
                  <span className={classes.count}>{unreadCount}</span>
                </div>
              }
              {...a11yProps(0)}
            />
            <Tab
              classes={{ root: classes.tab }}
              label={
                <div className={classes.activeTabWrap}>
                  <Typography sx={{ fontWeight: 'bold' }} variant="h5" component="span">
                    {t('inactive')}
                  </Typography>
                </div>
              }
              {...a11yProps(1)}
            />
          </Tabs>
        </Box>
      </Box>
      <TabPanel value={tabValue} index={0}>
        <ChatListInboundMessages selectedConversationId={selectedConversationId} onSelectConversation={onSelectConversation} tabValue={tabValue} />
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <ChatListInactiveMessages selectedConversationId={selectedConversationId} onSelectConversation={onSelectConversation} tabValue={tabValue} />
      </TabPanel>
      <div className={classes.shadow} />
    </div>
  );
}

ChatList.propTypes = {
  selectedConversationId: PropTypes.string,
  onSelectMessage: PropTypes.func.isRequired,
};

ChatList.defaultProps = {
  selectedConversationId: null,
};

export default ChatList;
